import * as Swiper from "../libs/swiper";
import { animateImages } from "./animate-images";

export function howitworksSlider() {
    this.$window.on("load", function () {
        const slider = $(".howitworks-slider");

        const sliderSettings = {
            slidesPerView: "auto",
            spaceBetween: 10,
            watchOverflow: true,
            loop: false,
            centeredSlides: true,
            fadeEffect: { crossFade: true },
            effect: "fade",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        };


        const mySwiper = new Swiper(slider, sliderSettings);

        // mySwiper.on("slideChange", function() {
        //     const animateWrapper = document.querySelectorAll(".howitworks-slider .swiper-slide")[mySwiper.realIndex].querySelector(".animated-images");
        //     animateImages(animateWrapper);
        // });

    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/howitworks-slider.js